import { atomWithStorage } from '@capsicum/common';
import { atom, type Atom } from 'jotai';

interface SurveyAnswer {
	selectedAnswerId: string;
	surveyId: string;
}

// Helper function to create add/update atom logic
const createAddOrUpdateSurveyAnswerAtom = (storageAtom: any) =>
	atom(
		get => get(storageAtom),
		(get, set, { selectedAnswerId, surveyId }) => {
			const currentAnswers: Array<SurveyAnswer> = get(storageAtom);

			// Check if the survey already exists
			const existingIndex = currentAnswers.findIndex(answer => answer.surveyId === surveyId);

			let newAnswers: Array<SurveyAnswer>;

			if (existingIndex !== -1) {
				// Update the existing entry
				newAnswers = [...currentAnswers];
				newAnswers[existingIndex] = { selectedAnswerId, surveyId };
			} else {
				// Add a new entry
				newAnswers = [...currentAnswers, { selectedAnswerId, surveyId }];
			}

			// Update the atom
			set(storageAtom, newAnswers);
		}
	);

// Helper function to create getter atom logic
const createGetSurveyAnswerAtom = (storageAtom: Atom<Array<SurveyAnswer>>, surveyId: string) =>
	atom(get => {
		const surveyAnswers: Array<SurveyAnswer> = get(storageAtom);
		const answer = surveyAnswers.find(item => item.surveyId === surveyId);

		return answer || null; // Return null if no answer found
	});

// Atoms using localStorage for web
const surveyVotesAtom = atomWithStorage<Array<SurveyAnswer>>('surveyVotes', []);

export const addOrUpdateSurveyAnswerAtom = createAddOrUpdateSurveyAnswerAtom(surveyVotesAtom);
// @ts-ignore
export const getSurveyAnswerAtom = (surveyId: string) => createGetSurveyAnswerAtom(surveyVotesAtom, surveyId);
